export const CANCEL_CHANGES = 'CANCEL_CHANGES';

export function cancelChanges(widget: string): any {
  return {
    type: CANCEL_CHANGES,
    payload: { widget }
  };
}
